module.exports = __webpack_public_path__ + "media/images/clothes2-c56e993d2e20d4970bccecba38ab738f.jpg";